// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/precision-springs/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const precisionSpringsEN: PageEntry = {
  id: "product.en-precision-springs",
  locale: "en",
  slug: "precision-springs",
  seo: {
    title: "Glossary: Precision springs explained simply | Dietz GmbH",
    description: "Precision springs are special spring components that fulfil high requirements in terms of tolerances, material quality and performance. These springs are often used in applications",
  },
  type: "post",
  h1: "Glossary: Precision springs explained simply",
  intro: "Precision springs are special spring components that fulfil high requirements in terms of tolerances, material quality and performance. These springs are often used in applications where precision and reliability are critical, such as medical technology, aerospace or metrology. The manufacture of precision springs requires advanced manufacturing technologies and accurate quality control to ensure that the springs meet the required specifications and can operate effectively in demanding environments.",
  blocks: [

  ],
};
